export const updateUrlParams = (
    params: Record<string, string | null | undefined>,
    replace?: boolean,
) => {
    const url = new URL(window.location.href);
    const oldUrl = url.toString();

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            url.searchParams.set(key, value);
        } else if (value === null) {
            url.searchParams.delete(key);
        }
    });

    if (oldUrl === url.toString()) {
        return;
    }

    if (replace) {
        window.history.replaceState(window.history.state, "", url.toString());
    } else {
        window.history.pushState(window.history.state, "", url.toString());
    }
};
